const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M5 19.25a.75.75 0 0 1-.75-.75v-13a.75.75 0 0 1 1.5 0v13a.75.75 0 0 1-.75.75m4-14a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zm0 12a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zm0-6a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  a as w
};
